import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { PackageEntitlement } from './package-entitlement';
export { PackageEntitlement };
import { packageEntitlementSchema } from '@schemas/business-objects/package-entitlement';
import { UserFormGroup } from './user-form-group';

export class PackageEntitlementFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    kind: SchemaFormControl;
    packageNamePattern: SchemaFormControl;
    expiresAt: SchemaFormControl;
    source: SchemaFormControl;
    userId: SchemaFormControl;
    user: UserFormGroup;
  };

  declare value: Partial<PackageEntitlement>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(packageEntitlementSchema, PackageEntitlement, data, options);
  }

  get object(): PackageEntitlement {
    return new PackageEntitlement(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'user':
        return new UserFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<PackageEntitlement[]> {
    return PackageEntitlement.find(filter);
  }

  static async findOne(filter?: any): Promise<PackageEntitlement | null> {
    return PackageEntitlement.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<PackageEntitlement> {
    return PackageEntitlement.findById(id, filter);
  }

  static async create(
    data: Partial<PackageEntitlement>,
  ): Promise<PackageEntitlement> {
    return PackageEntitlement.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<PackageEntitlement>,
  ): Promise<PackageEntitlement> {
    return PackageEntitlement.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return PackageEntitlement.deleteById(id);
  }
}

export class PackageEntitlementFormArray extends PersistedFormArray {
  declare controls: PackageEntitlementFormGroup[];

  readonly entityName = 'PackageEntitlement' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(packageEntitlementSchema, PackageEntitlement, options);
  }

  protected override createItemGroup() {
    return new PackageEntitlementFormGroup();
  }

  get array(): PackageEntitlement[] {
    return this.controls.map(
      (group: PackageEntitlementFormGroup) => group.object,
    );
  }
}

export class PackageEntitlementPersistedArray extends PersistedArray<PackageEntitlement> {
  readonly entityName = 'PackageEntitlement' as const;

  constructor(options?: PersistedArrayOptions) {
    super(PackageEntitlement, options);
  }
}
